import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/faqs';

// Get all faqs info
export async function getFaqs() {
  return await sendRequest(BASE_URL, 'GET');
}

//Create a faq
export async function postFaq(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

//Edit a faq
export async function editFaq(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

//Delete a faq
export async function deleteFaq(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
